/* eslint-disable */
export const list = state => state.list;
export const payment = state => state.payment;
export const newPayment = state => state.newPayment;
export const updateSubscription = state => state.updateSubscription;
export const newPaymentStatus = state => state.newPaymentStatus;
export const newPaymentError = state => state.newPaymentError;
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersPaymentInitialDate = state => state.filtersPaymentInitialDate;
export const filtersPaymentFinalDate = state => state.filtersPaymentFinalDate;
export const filtersCardBrand = state => state.filtersCardBrand;
export const filtersTerminalNumber = state => state.filtersTerminalNumber;
export const filtersNsuAcquirer = state => state.filtersNsuAcquirer;
export const filtersOperation = state => state.filtersOperation;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersStatus = state => state.filtersStatus;
export const currentPage = state => state.currentPage;
export const totalResources = state => state.totalResources;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const loadingData = state => state.loadingData;
export const subtotal = state => state.subtotal;
export const filterStatus = state => state.filterStatus;
export const showFilters = state => state.showFilters;
export const filterParams = state => state.filterParams;
export const filtersPartner = state => state.filtersPartner;
export const filtersMinAmount = state => state.filtersMinAmount;
export const filtersMaxAmount = state => state.filtersMaxAmount;
export const page = state => state.page;

export const filter = state => {
  const filters = {
    page: state.currentPage || 1,
    limit: state.limit || 10,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      credit_card_brand: state.filtersCardBrand,
      with_terminal_number: state.filtersTerminalNumber,
      nsu_acquirer_cont: state.filtersNsuAcquirer,
      status: state.filtersStatus,
      operation: state.filtersOperation,
      sorted_by: state.filtersOrdination,
      with_partner: state.filtersPartner
    },
    nsu_acquirer_cont: state.filtersNsuAcquirer
  };
  return filters;
};

export const pagination = state => {
  const page_set = {
    page: state.currentPage,
    rowsPerPage: state.limit,
    totalItems: state.totalResources,
    // rowsPerPageText: "Linhas por página"
  };
  return page_set;
};